import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_d_11512_209247)" }, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.16821",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#B82025"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "6.5",
    y: "6.66821",
    width: "33",
    height: "33",
    rx: "5.78571",
    stroke: "white",
    "stroke-width": "3",
    fill: "#B82025"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_11512_209247",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "8",
  y: "8",
  width: "30",
  height: "31"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.16821",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#FF0000"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_11512_209247)" }, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "37.4643",
    cy: "12.9897",
    r: "14.4643",
    fill: "#C64D51"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "4.24993",
    cy: "36.561",
    r: "21.9643",
    fill: "#E13E49"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter1_d_11512_209247)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M18.828 13.4082C18.5412 13.4082 18.2822 13.5797 18.1703 13.8438L14.956 21.4295L14.953 21.4368C14.8641 21.6532 14.8297 21.8881 14.8528 22.121C14.876 22.3538 14.956 22.5774 15.0858 22.7721C15.2155 22.9667 15.3912 23.1266 15.5972 23.2375C15.8032 23.3484 16.0333 23.407 16.2673 23.4082L16.2708 23.4082H19.3096L16.7126 32.4976C16.6242 32.8072 16.7537 33.1376 17.0289 33.3046C17.3042 33.4716 17.6571 33.4338 17.8907 33.2123L30.1622 21.5838L30.1665 21.5797C30.3703 21.3833 30.5112 21.1307 30.5713 20.854C30.6313 20.5773 30.6078 20.289 30.5038 20.0258C30.3996 19.7625 30.2196 19.5361 29.9866 19.3752C29.7536 19.2144 29.4781 19.1265 29.1951 19.1226L29.1852 19.1225H24.9837L27.3241 14.4419C27.4348 14.2205 27.4229 13.9576 27.2928 13.747C27.1626 13.5364 26.9327 13.4082 26.6851 13.4082H18.828Z",
    fill: "white"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_d_11512_209247",
    x: "1",
    y: "1.16821",
    width: "44",
    height: "44",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset"),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.721569 0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0.5 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209247"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209247",
      result: "shape"
    })
  ]),
  /*#__PURE__*/_createVNode("filter", {
    id: "filter1_d_11512_209247",
    x: "9.13154",
    y: "13.4082",
    width: "27.1865",
    height: "31.4286",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "5.71429" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2.85714" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209247"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209247",
      result: "shape"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}